(function ($) {
  'use strict';
  $.fn.scrollTo = function (duration) {
    if (typeof duration === 'undefined') {
      duration = 1000;
    }
    $('html, body').animate(
      {
        scrollTop: this.offset().top,
      },
      duration
    );
  };
})(jQuery);
